













import './KisweRibbon.scss'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'KisweRibbon',
  props: {
    label: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: false,
      default: true
    },
    side: {
      type: String as () => 'left'|'right',
      required: false,
      default: 'right'
    }
  }
})
